import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "dialogs-component",
        {
          key: _vm.key_search_table,
          ref: "dialogTable",
          attrs: { title: "Solicitar Acceso", width: 900 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              !_vm.isRequest
                ? _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Tabla / Vista a Buscar:")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "8" } },
                        [
                          _c(
                            VTextField,
                            {
                              staticClass: "busqueda",
                              attrs: {
                                outlined: true,
                                "hide-details": "auto",
                                dense: "",
                                "class-input": "mt-0 col-md-6",
                              },
                              model: {
                                value: _vm.textSearch,
                                callback: function ($$v) {
                                  _vm.textSearch = $$v
                                },
                                expression: "textSearch",
                              },
                            },
                            [
                              _c(
                                "template",
                                { staticClass: "mt-0", slot: "append-outer" },
                                [
                                  _c(VCombobox, {
                                    staticClass: "mt-0 col-md-6",
                                    attrs: {
                                      items: _vm.processd_list_domains,
                                      "hide-details": "auto",
                                      outlined: "",
                                      disabled: _vm.disabledDomain,
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.pick_domain,
                                      callback: function ($$v) {
                                        _vm.pick_domain = $$v
                                      },
                                      expression: "pick_domain",
                                    },
                                  }),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "pointer",
                                      attrs: { icon: "" },
                                      on: { click: _vm.reloadListV2 },
                                    },
                                    [_c(VIcon, [_vm._v("icon-search")])],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isRequest
                ? _c(
                    "div",
                    [
                      _c(
                        VRow,
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.existeBusqueda,
                              expression: "existeBusqueda",
                            },
                          ],
                        },
                        [
                          _c(
                            VCard,
                            { staticClass: "pb-3" },
                            _vm._l(
                              _vm.encontrado.busqueda,
                              function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key:
                                      "item_" +
                                      item.id +
                                      "_" +
                                      item.titulo +
                                      "_" +
                                      _vm.getRamdonKey(),
                                    staticClass: "item-busqueda",
                                  },
                                  [
                                    item.tipo_objeto ==
                                      _vm.TYPSE_SENSE_TYPE_OBJECTS.TABLE ||
                                    item.tipo_objeto ==
                                      _vm.TYPSE_SENSE_TYPE_OBJECTS.VIEW
                                      ? _c("item-table-view-component", {
                                          attrs: {
                                            item: item,
                                            "show-view": false,
                                            "show-change": false,
                                          },
                                          on: {
                                            onRequestObjeto:
                                              _vm.onRequestObjeto,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                          [
                            _c(
                              "div",
                              { staticClass: "text-left mt-3" },
                              [
                                _c(VPagination, {
                                  attrs: {
                                    length:
                                      _vm.encontrado.found &&
                                      _vm.encontrado.per_page
                                        ? Math.ceil(
                                            _vm.encontrado.found /
                                              _vm.encontrado.per_page
                                          )
                                        : 0,
                                    "total-visible": 7,
                                    circle: "",
                                  },
                                  on: { input: _vm.nextPage },
                                  model: {
                                    value: _vm.encontrado.page,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.encontrado, "page", $$v)
                                    },
                                    expression: "encontrado.page",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                        ],
                        2
                      ),
                      _c(
                        VRow,
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.existeBusqueda,
                              expression: "!existeBusqueda",
                            },
                          ],
                        },
                        [
                          _c(VCol, [
                            _c("br"),
                            _vm._v(_vm._s(_vm.$t("search.no_results")) + " "),
                          ]),
                        ],
                        1
                      ),
                      false
                        ? _c(
                            VRow,
                            [
                              _c(
                                "b-col",
                                {
                                  attrs: {
                                    xl: "12",
                                    lg: "12",
                                    md: "12",
                                    sm: "12",
                                    xs: "12",
                                  },
                                },
                                _vm._l(
                                  _vm.queryResponse.tables,
                                  function (item) {
                                    return _c(
                                      "b-card",
                                      { key: item.id, staticClass: "mt-2" },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                attrs: {
                                                  xl: "11",
                                                  lg: "11",
                                                  md: "11",
                                                  sm: "11",
                                                  xs: "11",
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      {
                                                        attrs: {
                                                          xl: "12",
                                                          lg: "12",
                                                          md: "12",
                                                          sm: "12",
                                                          xs: "12",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticStyle: {
                                                              color: "#1a0dab",
                                                            },
                                                          },
                                                          [
                                                            _c("h5", [
                                                              item
                                                                .tableReference
                                                                .tableId
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          item
                                                                            .tableReference
                                                                            .tableId
                                                                        )
                                                                    ),
                                                                  ])
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      " No name"
                                                                    ),
                                                                  ]),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      {
                                                        attrs: {
                                                          xl: "12",
                                                          lg: "12",
                                                          md: "12",
                                                          sm: "12",
                                                          xs: "12",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticStyle: {
                                                              color: "#006621",
                                                            },
                                                          },
                                                          [
                                                            _c("h6", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "joinTableReference"
                                                                    )(
                                                                      item.tableReference
                                                                    )
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              {
                                                attrs: {
                                                  xl: "1",
                                                  lg: "1",
                                                  md: "1",
                                                  sm: "1",
                                                  xs: "1",
                                                },
                                              },
                                              [
                                                _vm.checkDomain(item)
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "badge badge-secondary mr-1",
                                                      },
                                                      [_vm._v(" E ")]
                                                    )
                                                  : _vm._e(),
                                                item.searchResultSubtype ===
                                                "entry.table"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "badge badge-success",
                                                      },
                                                      [_vm._v(" Table")]
                                                    )
                                                  : _vm._e(),
                                                item.searchResultSubtype ===
                                                "entry.table.view"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "badge badge-success",
                                                      },
                                                      [_vm._v(" View")]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                attrs: {
                                                  xl: "12",
                                                  lg: "12",
                                                  md: "12",
                                                  sm: "12",
                                                  xs: "12",
                                                },
                                              },
                                              [
                                                item.defaultFields
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-description",
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            " Description: "
                                                          ),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item
                                                                  .defaultFields[
                                                                  _vm
                                                                    .DEFAULT_TPL_FIELDS
                                                                    .DESCRIPTION
                                                                    .name
                                                                ]
                                                                  ? item
                                                                      .defaultFields[
                                                                      _vm
                                                                        .DEFAULT_TPL_FIELDS
                                                                        .DESCRIPTION
                                                                        .name
                                                                    ]
                                                                      .stringValue
                                                                  : ""
                                                              )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                attrs: {
                                                  xl: "6",
                                                  lg: "6",
                                                  md: "6",
                                                  sm: "12",
                                                  xs: "12",
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-row",
                                                  [
                                                    item.defaultFields
                                                      ? _c("b-col", [
                                                          _c("b", [
                                                            _vm._v(
                                                              " Data operator: "
                                                            ),
                                                          ]),
                                                          _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item
                                                                    .defaultFields[
                                                                    _vm
                                                                      .DEFAULT_TPL_FIELDS
                                                                      .OPERATOR
                                                                      .name
                                                                  ]
                                                                    ? item
                                                                        .defaultFields[
                                                                        _vm
                                                                          .DEFAULT_TPL_FIELDS
                                                                          .OPERATOR
                                                                          .name
                                                                      ]
                                                                        .stringValue
                                                                    : ""
                                                                )
                                                            ),
                                                          ]),
                                                        ])
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                item.schema.fields.length
                                                  ? _c(
                                                      "b-row",
                                                      [
                                                        _c("b-col", [
                                                          _c("b", [
                                                            _vm._v(
                                                              " Columns: "
                                                            ),
                                                          ]),
                                                          _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.schema
                                                                    .fields
                                                                    .length
                                                                )
                                                            ),
                                                          ]),
                                                        ]),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              {
                                                attrs: {
                                                  xl: "6",
                                                  lg: "6",
                                                  md: "6",
                                                  sm: "12",
                                                  xs: "12",
                                                },
                                              },
                                              [
                                                item.numRows
                                                  ? _c(
                                                      "b-row",
                                                      [
                                                        _c("b-col", [
                                                          _c("b", [
                                                            _vm._v(" Rows: "),
                                                          ]),
                                                          _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    item.numRows
                                                                  )
                                                                )
                                                            ),
                                                          ]),
                                                        ]),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                item.creationTime
                                                  ? _c(
                                                      "b-row",
                                                      [
                                                        _c("b-col", [
                                                          _c("b", [
                                                            _vm._v(
                                                              " Creation: "
                                                            ),
                                                          ]),
                                                          _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatDate"
                                                                  )(
                                                                    item.creationTime
                                                                  )
                                                                )
                                                            ),
                                                          ]),
                                                        ]),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        item.qFound
                                          ? _c(
                                              "b-row",
                                              { staticClass: "mt-1" },
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    attrs: {
                                                      xl: "6",
                                                      lg: "6",
                                                      md: "6",
                                                      sm: "12",
                                                      xs: "12",
                                                    },
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(" Found in: "),
                                                    ]),
                                                    item.qFound.element
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.qFound
                                                                  .element
                                                              ) +
                                                              ": " +
                                                              _vm._s(
                                                                item.qFound
                                                                  .value
                                                              )
                                                          ),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            " Others (type) "
                                                          ),
                                                        ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "b-row",
                                          { staticClass: "mt-2" },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                attrs: {
                                                  xl: "12",
                                                  lg: "12",
                                                  md: "12",
                                                  sm: "12",
                                                  xs: "12",
                                                },
                                              },
                                              [
                                                _c(
                                                  VBtn,
                                                  {
                                                    staticClass: "secondary",
                                                    style: {
                                                      "background-color":
                                                        "rgb(0,0,102)",
                                                      color: "white",
                                                    },
                                                    attrs: { size: "sm" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openRequestAccess(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" Request access ")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isRequest
                ? _c(
                    "div",
                    [
                      _c(
                        VTooltip,
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var attrs = ref.attrs
                                  var on = ref.on
                                  return [
                                    _c(
                                      VBtn,
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "btn-back-view",
                                            attrs: { icon: "" },
                                            on: { click: _vm.onCancelar },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(VIcon, [
                                          _vm._v(
                                            "mdi-arrow-left-thin-circle-outline"
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2493179393
                          ),
                        },
                        [_c("span", [_vm._v("Volver a buscar.")])]
                      ),
                      _c("form-access-request-table-component", {
                        ref: "requestFormRef",
                        attrs: {
                          "tpl-to-work": _vm.objToRequest,
                          "is-audience": _vm.isAudience,
                          "is-attributes": _vm.isAttributes,
                          "is-productivize": _vm.isProductivize,
                          "request-message": _vm.getMessageProductivize(),
                          "use-case": _vm.external_row.table_sandbox,
                        },
                        on: { submit: _vm.sendRequest, cancel: _vm.onCancelar },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("pagination-searching", {
                attrs: {
                  "query-object": _vm.queryResponse,
                  "reload-method": _vm.reloadList,
                  "is-new-query": _vm.isNewQuery,
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _vm.isRequest
                ? _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.requestFormRef.onSubmit($event)
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }